import View from '../../../View'
import {connect} from '../../../redux/utils'
import {bindActionCreators} from 'redux'
import {isLoading, isNeedToLoadData, isShown} from './selectors'
import PanelContainer from "../../../components/PanelContainer";
import CreateUserPanelContainer from "./CreateUserPanelContainer";
import {cancelUserCreation, loadCreateUserPanelData, closeCreateUserPanel} from "./actions";
import LoadingContainer from "../../../util/LoadingContainer";
import {HIDE_ANIMATION_CLASSES, SHOW_ANIMATION_CLASSES} from "../../constants";
import CreateUserManagementAssignmentsEditorPanel from '../../../administration/userManagement/createUserManagementAssignmentsEditor/components/CreateUserManagementAssignmentsEditorPanel'
import CreateManagementAssignmentsPanel from '../../../administration/userManagement/createManagementAssignmentsPanel/components/ManagementAssignmentsPanel'
import CreateTeamAssignmentsPanel from '../createTeamAssignmentsPanel/CreateTeamAssignmentsPanel'

class CreateUserPanel extends View {
    constructor({
        onPanelHide = () => {},
        loadCreateUserPanelData = () => {},
        cancelUserCreation = () => {},
    }) {
        super()

        this.onPanelHide = onPanelHide
        this.loadCreateUserPanelData = loadCreateUserPanelData
        this.cancelUserCreation  = cancelUserCreation

        this.state = {
            isShown: false,
            needToLoadData: false,
            loading: false
        }

        this.onStatePropertyChanged('isShown', isShown => {
            this.createUserPanelContainerWrapper.setState({isShown})
        })

        this.onStatePropertyChanged('needToLoadData', (needToLoadData, prevNeedToLoadData) => {
            if (needToLoadData !== prevNeedToLoadData && needToLoadData === true) {
                this.loadCreateUserPanelData()
            }
        })

        this.onStatePropertyChanged('loading', loading => this.loadingWrapper.setState({loading}))
    }

    afterRender() {
        this.loadingWrapper = new LoadingContainer({
            contentComponent: new CreateUserPanelContainer(),
            containerClass: 'userPanelLoadingWrapper'

        })
        this.createUserPanelContainerWrapper = new PanelContainer({
            component: this.loadingWrapper,
            additionalClass: "create_user_sliding_panel sliding_panel",
            showAnimationClass: SHOW_ANIMATION_CLASSES.SLIDE_LEFT,
            hideAnimationClass: HIDE_ANIMATION_CLASSES.SLIDE_LEFT,
            showHideButton: false,
            hideOnEsc: true,
            showMoire: true,
            onHideCallback: () => this.onPanelHide(),
            hideHandler: () => this.cancelUserCreation(),
        }).init(this.$containerEl)

        this.registerChildComponents(new CreateTeamAssignmentsPanel().init(this.$containerEl))

        this.registerChildComponents(new CreateManagementAssignmentsPanel().init(this.$containerEl))

        this.registerChildComponents(new CreateUserManagementAssignmentsEditorPanel().init(this.$containerEl))
    }
}

export default connect(
    state => ({
        isShown: isShown(state),
        needToLoadData: isNeedToLoadData(state),
        loading: isLoading(state)
    }),
    dispatch => ({
        cancelUserCreation: bindActionCreators(cancelUserCreation, dispatch),
        onPanelHide: bindActionCreators(closeCreateUserPanel, dispatch),
        loadCreateUserPanelData: bindActionCreators(loadCreateUserPanelData, dispatch),
    })
)(CreateUserPanel)



// WEBPACK FOOTER //
// ./web/js/panels/user/createPanel/CreateUserPanel.js